// extracted by mini-css-extract-plugin
export default {"wrapper":"Layout_wrapper__AJsX2","main":"Layout_main__FV28D"};